import { createFileRoute, Navigate } from '@tanstack/react-router'
import { useAuth } from '@/context/auth-context'
import { getDefaultNavigationUrl } from '@/lib/navigation-utils'
import { useEffect, useState } from 'react'

function AuthenticatedIndex() {
  const { user, isAuthenticated } = useAuth()
  const [redirectUrl, setRedirectUrl] = useState<string | null>(null)

  useEffect(() => {
    if (isAuthenticated && user) {
      // Get user permissions as string array
      const userPermissions = user.permissions?.map(p => p.name) || []

      // Get the default navigation URL based on user permissions and priority
      const defaultUrl = getDefaultNavigationUrl(userPermissions)

      setRedirectUrl(defaultUrl)
    }
  }, [isAuthenticated, user])

  // // Show loading state while authentication is being checked
  // if (isLoading) {
  //   return (
  //     <div className="flex items-center justify-center min-h-screen">
  //       <div className="text-center">
  //         <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
  //         <p className="text-muted-foreground">Loading...</p>
  //       </div>
  //     </div>
  //   )
  // }

  // If not authenticated, this shouldn't happen since we're in _authenticated route
  // but handle it gracefully
  if (!isAuthenticated) {
    return <Navigate to="/sign-in" replace />
  }

  // If we have a redirect URL, navigate to it
  if (redirectUrl) {
    return <Navigate to={redirectUrl} replace />
  }

  // Fallback to employees page if no redirect URL is determined
  return <Navigate to="/employees" replace />
}

export const Route = createFileRoute('/_authenticated/')({
  component: AuthenticatedIndex,
})
